import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class BacklogIdeasIndexRoute extends Route {
  @service router;

  beforeModel() {
    this.router.transitionTo('backlog.ideas.list');
  }
}
